const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/admin/sms/send-config/channel.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { SmsSendConfigTplFilterParamSchema } from '@apps/main/features/admin/pages/sms/send-config-tpl-config-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/admin/sms/send-config/channel')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: SmsSendConfigTplFilterParamSchema
});